export class TrackUtils {
    static alertMessage = `<p>Трек-номер корректен?</p>
    <p>Is the tracking number correct?</p>
    <p>Бақылау нөмірі дұрыс па?</p>`;


    /**
     * Check and clean a track number
     * 
     * @param tracknum track numer from a user
     * @returns cleared track (trimmed and upper cased) number or null if the number in the wrong format
     */
    static checkTrack(tracknum: string): string | null {
        if (tracknum && tracknum.length >= 8 && tracknum.length <= 22) {
            tracknum = tracknum.trim().toUpperCase();

            const res = tracknum.match(/^([A-Z]{0,4}[0-9]+[-]?[A-Z]{0,4})$/g)?.length;

            if (res && res === 1) {
                return tracknum;
            }
        }

        return null;
    }
}